import { Controller } from "@hotwired/stimulus";

// Shows/hides a panel. The trigger is a real <button> whose aria-expanded
// reflects the state; its closed/open labels swap with the panel.
export default class extends Controller {
  static targets = ["button", "panel", "closedLabel", "openLabel", "summary"];

  toggle() {
    const expanded = this.panelTarget.hidden;
    this.panelTarget.hidden = !expanded;
    this.buttonTarget.setAttribute("aria-expanded", String(expanded));
    this.closedLabelTarget.hidden = expanded;
    this.openLabelTarget.hidden = !expanded;
    this.summaryTargets.forEach((el) => (el.hidden = expanded));
    if (expanded) this.panelTarget.querySelector("input, textarea")?.focus();
  }
}
